import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import styles from './Counter.module.scss'

const Counter = ({ current, all, className, onButtonClick }) => {
    const { t } = useTranslation()

    const isLastTab = current === all

    return (
        <div className={classNames(styles.counter, { [className]: !!className })}>
            <div className={styles.numbers}>
                {current}/{all}
            </div>
            <button className="button" data-size="lg" data-variant="primary" onClick={() => onButtonClick()}>
                {isLastTab ? t('Finish tutorial') : t('Next')}
            </button>
        </div>
    )
}

export default Counter
